export enum FeedbackType {
    CHECKIN = 'CHECKIN',
    COMMENT = 'COMMENT',
    REPORT = 'REPORT'
}

export enum AWSSentiment {
    POSITIVE = 'POSITIVE',
    NEGATIVE = 'NEGATIVE',
    MIXED = 'MIXED',
    NEUTRAL = 'NEUTRAL'
}

export enum ModerationType {
    MODERATION = 'MODERATION',
    CONTROL = 'CONTROL'
}

export enum ConnectorTypeSlug {
    DOMESTIC_TYPE_A = 'DOMESTIC_TYPE_A',
    DOMESTIC_TYPE_B = 'DOMESTIC_TYPE_B',
    DOMESTIC_TYPE_C = 'DOMESTIC_TYPE_C',
    DOMESTIC_TYPE_D = 'DOMESTIC_TYPE_D',
    DOMESTIC_TYPE_F = 'DOMESTIC_TYPE_F',
    DOMESTIC_TYPE_G = 'DOMESTIC_TYPE_G',
    DOMESTIC_TYPE_H = 'DOMESTIC_TYPE_H',
    DOMESTIC_TYPE_I = 'DOMESTIC_TYPE_I',
    DOMESTIC_TYPE_J = 'DOMESTIC_TYPE_J',
    DOMESTIC_TYPE_K = 'DOMESTIC_TYPE_K',
    DOMESTIC_TYPE_L = 'DOMESTIC_TYPE_L',
    DOMESTIC_TYPE_M = 'DOMESTIC_TYPE_M',
    MENNEKES_TYPE_2 = 'MENNEKES_TYPE_2',
    TYPE_3C = 'TYPE_3C',
    TYPE_1 = 'TYPE_1',
    CEE_BLUE = 'CEE_BLUE',
    CEE_RED = 'CEE_RED',
    CHADEMO = 'CHADEMO',
    TYPE_3A = 'TYPE_3A',
    NEMA_5_20 = 'NEMA_5_20',
    TESLA_ROADSTER = 'TESLA_ROADSTER',
    AVCON = 'AVCON',
    LARGE_PADDLE_INDUCTIVE = 'LARGE_PADDLE_INDUCTIVE',
    SMALL_PADDLE_INDUCTIVE = 'SMALL_PADDLE_INDUCTIVE',
    COMBO_TYPE_2 = 'COMBO_TYPE_2',
    COMBO_TYPE_1 = 'COMBO_TYPE_1',
    CHINA_GB_PART_2 = 'CHINA_GB_PART_2',
    CHINA_GB_PART_3 = 'CHINA_GB_PART_3',
    MARECHAL = 'MARECHAL',
    IEC_309_DC = 'IEC_309_DC',
    T23 = 'T23',
    T15 = 'T15',
    T25 = 'T25',
    TESLA_TYPE_2 = 'TESLA_TYPE_2',
    MENNEKES_TYPE_2_CABLE_ATTACHED = 'MENNEKES_TYPE_2_CABLE_ATTACHED',
    TESLA_SUPERCHARGER_EU = 'TESLA_SUPERCHARGER_EU',
    TESLA_COMBO_CCS = 'TESLA_COMBO_CCS'
}

export enum ReportReasonType {
    DELIVERED_POWER_TOO_WEAK = 'DELIVERED_POWER_TOO_WEAK',
    CONNEXION_OR_AUTHENTICATION_IMPOSSIBLE = 'CONNEXION_OR_AUTHENTICATION_IMPOSSIBLE',
    SESSION_NOT_STARTING = 'SESSION_NOT_STARTING',
    SESSION_INTERRUPTED = 'SESSION_INTERRUPTED',
    CONNECTOR_DAMAGED = 'CONNECTOR_DAMAGED',
    PLACE_OCCUPIED_BY_NON_CHARGING_VEHICLE = 'PLACE_OCCUPIED_BY_NON_CHARGING_VEHICLE',
    ZONE_OCCUPIED_BY_CHARGING_VEHICLE = 'ZONE_OCCUPIED_BY_CHARGING_VEHICLE',
    POOL_NOT_PUBLIC = 'POOL_NOT_PUBLIC',
    POOL_DEFINITIVELY_CLOSED = 'POOL_DEFINITIVELY_CLOSED',
    POOL_TEMPORARILY_INACCESSIBLE = 'POOL_TEMPORARILY_INACCESSIBLE',
    POOL_POWERED_OFF = 'POOL_POWERED_OFF',
    CHARGING_IMPOSSIBLE_OUTSIDE_OPENING_HOURS = 'CHARGING_IMPOSSIBLE_OUTSIDE_OPENING_HOURS',
    WRONG_DATA_DISPLAYED = 'WRONG_DATA_DISPLAYED'
}

export enum PassState {
    ORDERED = 'ORDERED',
    IN_STOCK = 'IN_STOCK',
    ASSIGNED = 'ASSIGNED',
    ACTIVATED = 'ACTIVATED',
    DELETED = 'DELETED',
    LOST = 'LOST'
}

export interface ChargemapResponse {
    feedbackId: number
    publicContent: string | null
    creationDate: string
}

export interface PartnerResponse {
    feedbackId: number
    partnerId: number
    partnerName: string
    content: string
    creationDate: string
}

export interface Rating {
    id: number
    globalNote: number
    materialNote: number | null
    priceNote: number | null
    locationNote: number | null
    securityNote: number | null
    comment: string | null
    locale: string | null
    sentiment: AWSSentiment | null
    isCommentModerated: boolean
}

export interface Feedback {
    type: FeedbackType
    id: number
    userId: number
    userUsername: string | null
    userPassId: number | null
    userPassState: PassState | null
    poolId: number
    poolName: string
    poolSlug: string
    isAnonymous: boolean
    creationDate: string
    modificationDate: string | null
    moderationType?: ModerationType
    rating?: Rating
    chargemapResponse?: ChargemapResponse
    partnerResponse?: PartnerResponse
    displayShowOlderCommentsLabel?: boolean
}

export interface Comment extends Feedback {
    comment: string | null
    locale: string | null
    sentiment: AWSSentiment | null
    isCommentModerated: boolean
}

export interface Checkin extends Feedback {
    chargeStartDate: string
    chargeEndDate: string | null
    isChargeWithPass: boolean
    vehicleVersionId: number | null
    vehicleBrandName: string | null
    vehicleModelName: string | null
    vehicleVersionName: string | null
    connectorType: ConnectorTypeSlug | null
    connectorMaxPower: number | null
}

export interface Report extends Feedback, Comment {
    incidentDate: string
    reasonType: ReportReasonType
    isOperatorWarned: boolean | null
}
